import { render, staticRenderFns } from "./VRadioMatrix.vue?vue&type=template&id=452eb426&scoped=true"
import script from "./VRadioMatrix.vue?vue&type=script&lang=js"
export * from "./VRadioMatrix.vue?vue&type=script&lang=js"
import style0 from "./VRadioMatrix.vue?vue&type=style&index=0&id=452eb426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452eb426",
  null
  
)

export default component.exports